module.exports = __webpack_public_path__ + "static/img/lk.497ee5b9.svg";